import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { apiClient, formatApiError } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw !== confirm) return setError("Passwords don't match");
    setLoading(true);
    try {
      await apiClient.post("/auth/reset-password", { token, password: pw });
      toast.success("Password reset successful. Sign in with your new password.");
      navigate("/login");
    } catch (e) { setError(formatApiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F9F8] p-8">
      <div className="w-full max-w-md">
        <div className="mb-10"><Logo /></div>
        <div className="font-overline text-[#4A5568] mb-3">Reset</div>
        <h1 className="font-serif text-4xl text-[#0A192F] tracking-tight mb-2">Choose a new password</h1>
        <p className="text-[#4A5568] text-sm mb-8">Min 10 chars, with upper/lower, digit, and a symbol.</p>
        {!token ? (
          <div className="text-sm text-[#EF4444]" data-testid="reset-no-token">
            Missing reset token. <Link to="/forgot-password" className="underline">Request a new link</Link>.
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
            <div>
              <Label className="text-xs uppercase tracking-[0.15em] font-bold text-[#4A5568]">New password</Label>
              <Input type="password" required value={pw} onChange={(e) => setPw(e.target.value)} className="mt-2 h-11 rounded-sm bg-white" data-testid="reset-pw" />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-[0.15em] font-bold text-[#4A5568]">Confirm</Label>
              <Input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-2 h-11 rounded-sm bg-white" data-testid="reset-confirm" />
            </div>
            {error && <div className="text-sm text-[#EF4444]" data-testid="reset-error">{error}</div>}
            <Button type="submit" disabled={loading} className="w-full h-11 bg-[#0A192F] hover:bg-[#0A192F]/90 rounded-sm" data-testid="reset-submit">
              {loading ? "Saving…" : "Save new password"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
